<template>
 <ButtonGroup :config="buttonConfig" @button-click="onButtonClick($event)" />
</template>

<script>
import { mapState } from 'vuex';
import ButtonGroup from '@/components/ButtonGroup.vue';
import dateTimeFormatter from '@/utils/dateTimeFormatter';

// 可申請退貨的訂單狀態
const orderReturnStatus = {
  status: ['completed'],
  deliveryStatus: ['received'],
};

const orderCancelStatus = {
  status: ['processing'],
  deliveryStatus: ['undelivered', 'processing', 'uncollected'],
};

export default {
  components: { ButtonGroup },
  props: {
    order: {
      type: Object,
    },
    buttonConfigBase: {
      type: Object,
    },
  },
  data() {
    return {
      buttons: [
        {
          type: 'contactServiceCenter',
          dataType: '',
          text: '',
          variant: 'light',
          class: 'px-3 mx-1 font-size-md',
          disabled: false,
          action() { },
        },
        {
          type: 'orderReturn',
          dataType: '',
          text: '',
          variant: 'light',
          class: 'px-3 mx-1 font-size-md',
          disabled: false,
          action(vm, order) {
            vm.$emit('buttonEvent', 'return', order);
          },
        },
        {
          type: 'orderCancel',
          dataType: '',
          text: '',
          variant: 'light',
          class: 'px-3 mx-1 font-size-md',
          disabled: false,
          action(vm, order) {
            vm.$emit('buttonEvent', 'cancel', order);
          },
        },
        {
          type: 'buyAgain',
          dataType: '',
          text: '',
          variant: 'primary',
          class: 'px-3 mx-1 border-0 bg-customize font-size-md',
          disabled: false,
          action() { },
        },
      ],
      // 訂單按鈕設定值
      buttonConfig: {
        size: 'sm',
        buttons: [],
      },
    };
  },
  computed: {
    ...mapState(['currentOrderTab']),
  },
  created() {
    const vm = this;
    if (vm.buttonConfigBase[vm.currentOrderTab]) {
      vm.$store.dispatch('getElectronicCommerce')
        .then((res) => {
          const { returnDays } = res;

          vm.buttonConfig.buttons = vm.buttonConfigBase[vm.currentOrderTab].reduce((accu, current) => {
            const button = vm.buttons.find((item) => item.type === current.type);

            // 跳過找不到type的button
            if (!button) {
              return accu;
            }

            button.text = current.text;
            button.dataType = current.dataType;

            // 若是為退貨按鈕，必須符合一定的條件
            if (current.type === 'orderReturn') {
              // 跳過不屬於電商中心的訂單
              if (!vm.order.isTEECOrder) {
                return accu;
              }

              // 跳過訂單狀態不可退貨的訂單
              const shippingReceivedEvent = vm.order.events.find((x) => x.category === 'Delivery' && x.status === 'received');
              if (!orderReturnStatus.status.includes(vm.order.status)
                  || !orderReturnStatus.deliveryStatus.includes(vm.order.deliveryStatus)
                  || shippingReceivedEvent === undefined) {
                return accu;
              }

              // 跳過已超過退貨期限的訂單
              const dateTimeString = dateTimeFormatter.formatTaiwanDateTime(new Date(shippingReceivedEvent.time));
              const deadline = new Date(dateTimeString.substring(0, 10)).getTime() + (returnDays + 1) * 24 * 60 * 60 * 1000;
              if (Date.now() >= deadline) {
                return accu;
              }

              // 已發過退貨申請的訂單，按鈕反灰不可點擊
              if (vm.order.isReturnRequest) {
                button.disabled = true;
                button.text = vm.$t('order.return.requested');
              }

              const orderOldestEvent = vm.order.events[vm.order.events.length - 1];
              // 退貨失敗要改按鈕文案
              if (orderOldestEvent.category === 'Return' && orderOldestEvent.status.toString() === '51') {
                button.disabled = true;
                button.text = vm.$t('order.return.reject');
              }
            }

            // 若為取消按鈕，必須符合一定條件
            if (current.type === 'orderCancel') {
              // 處理中 + 貨態-未出貨才顯示取消按鈕
              if (!(orderCancelStatus.status.includes(vm.order.status) && orderCancelStatus.deliveryStatus.includes(vm.order.deliveryStatus))) {
                return accu;
              }

              // 都有退貨紀錄不能取消
              if (vm.order.isReturnRequest) {
                return accu;
              }

              // 已申請過取消的訂單，按鈕反灰不可點擊
              if (vm.order.isCancelRequest) {
                button.disabled = true;
                button.text = vm.$t('order.cancel.requested');
              }

              const orderOldestEvent = vm.order.events[vm.order.events.length - 1];
              // 取消失敗要改按鈕文案
              if ((orderOldestEvent.category === 'Cancel' && orderOldestEvent.status.toString() === '51')) {
                button.disabled = true;
                button.text = vm.$t('order.cancel.reject');
              }
            }

            accu.push(button);
            return accu;
          }, []);
        });
    }
  },
  methods: {
    onButtonClick(event) {
      const vm = this;
      if (typeof (event.action) === 'function') {
        event.action(vm, vm.order, event.buttonType, event.buttonDataType);
      }
    },
    updateButton(buttonType, buttonInfo) {
      const vm = this;
      const button = vm.buttonConfig.buttons.find((x) => x.type === buttonType);
      if (button) {
        button.disabled = buttonInfo.disabled;
        button.text = buttonInfo.text;
      }
    },
  },
};
</script>
